import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';
import { progressService } from '@/services/progress';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useProgressEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: ''
    });

    const validations = {
        name: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => progressService.item.get(model.id),
        onSuccess: ({ data }) => (model.name = data.name),
        onError: () => router.push({ name: ROUTE_NAME_PROGRESS.ITEM.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => progressService.item.update(model.id, model.name),
            onSuccess: () => router.push({ name: ROUTE_NAME_PROGRESS.ITEM.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
